var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgESign = function SvgESign(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 24.5H24.5M16.0818 6.197C16.0818 6.197 16.0818 8.10406 17.9889 10.0111C19.8959 11.9182 21.803 11.9182 21.803 11.9182M8.53956 20.9861L12.5444 20.414C13.1221 20.3314 13.6574 20.0638 14.07 19.6511L23.7101 10.0111C24.7633 8.95788 24.7633 7.25024 23.7101 6.19699L21.803 4.28993C20.7498 3.23669 19.0421 3.23669 17.9889 4.28993L8.34886 13.93C7.93623 14.3426 7.66856 14.8779 7.58603 15.4556L7.01391 19.4604C6.88678 20.3504 7.6496 21.1132 8.53956 20.9861Z",
    stroke: "#B5B5B5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgESign, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/e-Sign.a89f617c.svg";
export { ForwardRef as ReactComponent };